<template>
  <b-modal ref="edit-loop-name-modal" :title="'Changer le nom de la boucle ' + currentDescription" hide-footer >
    <div class="container-fluid my-3">
      <b-form>
        <b-form-group
          label="Nouveau nom"
        >
          <b-form-input
            type="text"
            v-model="newDescription"
          />
        </b-form-group>
      </b-form>
        <div class="row justify-content-center mt-4">
          <b-button
            variant="outline-danger"
            @click="hideModal()"
            class="mr-5"
            >Annuler</b-button
          >
          <b-button
            variant="primary"
            @click="editLoop"
            >
            Valider
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import server from '../api/server.vue'

export default {
  name: 'edit-loop-name-modal',
  props: [],
  data() {
    return {
      loopToEdit: {},
      currentDescription: '',
      newDescription: '',
    }
  },
  methods: {
    editLoop () {
      const params = {
        'loop': this.loopToEdit.name,
        'name': this.loopToEdit.name,
        'description': this.newDescription,
      }
      server.updateGivenLoop(params).then((result) => {
        this.$emit('edit-loop-name-modal-closed', this.loopToEdit.name, this.newDescription)
        this.hideModal()
      })
    },
    resetData () {
      this.loopToEdit = {}
      this.currentDescription = ''
      this.newDescription = ''
    },
    hideModal () {
      this.resetData()
      this.$refs['edit-loop-name-modal'].hide()
    },
    showModal (loop) {
      this.loopToEdit = loop
      this.currentDescription = loop.description
      this.newDescription = loop.description
      this.$refs['edit-loop-name-modal'].show()
    },
  },
}
</script>

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/components/EditLoopNameModal.vue